import * as React from 'react';

const ClockFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="clock-fill_svg__24_small_clock_fill-a"
                d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0m5 10.5H9.5V3h1v6.5H15v1z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 2)">
            <mask id="clock-fill_svg__24_small_clock_fill-b" fill="#fff">
                <use xlinkHref="#clock-fill_svg__24_small_clock_fill-a" />
            </mask>
            <use
                fill="#45494E"
                xlinkHref="#clock-fill_svg__24_small_clock_fill-a"
            />
            <g mask="url(#clock-fill_svg__24_small_clock_fill-b)">
                <path fill="#000" d="M-2-2h24v24H-2z" />
            </g>
        </g>
    </svg>
);

ClockFillSvg.displayName = 'ClockFillSvg';
export default ClockFillSvg;
